module.exports = __webpack_public_path__ + "img/empty-list.6216bb17.png";